import { jsx as s } from "react/jsx-runtime";
import { tv as a } from "tailwind-variants";
const o = a({
  base: [
    "bg-blue-500",
    "font-secondary",
    "font-bold",
    "px-2",
    "py-1",
    "rounded-full",
    "text-center",
    "text-white",
    "text-sm",
    "tracking-wider",
    "uppercase",
    "w-max",
    "leading-none"
  ]
}), l = ({ className: e, children: t }) => /* @__PURE__ */ s("span", { className: o({ class: e }), children: t });
export {
  l as default
};
